// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert-warn[data-v-27d82a20]{background-color:#cfd8dc}.pending-status[data-v-27d82a20]{background-color:#e0e05e}.accept-status[data-v-27d82a20],.pending-status[data-v-27d82a20]{padding:0 5px 0 5px;font-weight:700}.accept-status[data-v-27d82a20]{background-color:green;color:#fff}.reject-status[data-v-27d82a20]{background-color:red;padding:0 5px 0 5px;color:#fff}", ""]);
// Exports
module.exports = exports;
